<script setup>
import { useTriviaStore } from "@stores/trivia";
import FeedbackChip from "@components/trivia/FeedbackChip.vue";

const triviaStore = useTriviaStore();
</script>

<template>
    <Transition name="fade" appear>
        <div
            v-if="
                triviaStore.photoPosition === 'docked' &&
                triviaStore.gameState !== 'results' &&
                !triviaStore.hasCorrectGuess
            "
            :class="[
                'trivia-guesses bg-marine-800 border-marine-500 flex flex-col overflow-y-auto border-r p-6 max-lg:hidden',
                triviaStore.photoExpanded && 'trivia-guesses--expanded',
            ]"
        >
        <p class="body-sm mb-4 leading-none font-bold uppercase opacity-60">
            Your guesses
        </p>

        <p v-if="triviaStore.roundGuesses.length === 0" class="body-sm">
            Your guesses will be displayed here.
        </p>

        <ul v-else class="flex flex-col gap-1">
            <li
                v-for="(guess, i) in [...triviaStore.roundGuesses].reverse()"
                :key="i"
                class="border-marine-500 grid h-10 grid-cols-3 items-center border border-l-2 px-4"
                :style="{ borderLeftColor: guess.temperatureHex }"
            >
                <span class="body-sm leading-none font-bold uppercase">
                    {{ guess.countryName }}
                </span>
                <span
                    class="body-sm text-right leading-none font-medium uppercase faded-text"
                >
                    {{ guess.distance }}
                </span>
                <FeedbackChip
                    :name="guess.temperatureName"
                    :hex="guess.temperatureHex"
                />
            </li>
        </ul>
    </div>
    </Transition>
</template>

<style scoped>
.trivia-guesses {
    grid-column: 1 / 6;
    grid-row: 5 / -1;
    z-index: 2;
    transition: grid-row 0.3s ease;
}

.trivia-guesses--expanded {
    grid-row: 2 / -1;
}
</style>
